import { StepDto, StepExecutionDto } from "../../../dtos";

export function isStepExecutionDto(step: StepDto | StepExecutionDto): step is StepExecutionDto {
    return Object.hasOwn(step, 'isComplete');
}